/** All split arithmetic happens in integer paise — float rupees drift (0.1 + 0.2 ≠ 0.3), and a
 *  split that doesn't sum exactly to the bill would be rejected by the server. */
export function toPaise(rupees: number): number {
  return Math.round(rupees * 100)
}

export function fromPaise(paise: number): number {
  return paise / 100
}

export function splitEqually(
  totalPaise: number,
  otherCount: number,
  includeYou: boolean
): { sharesPaise: number[]; yourSharePaise: number } {
  if (otherCount <= 0) return { sharesPaise: [], yourSharePaise: totalPaise }
  const participants = otherCount + (includeYou ? 1 : 0)
  const each = Math.floor(totalPaise / participants)
  const shares = Array.from({ length: otherCount }, () => each)
  const remainder = totalPaise - each * participants
  if (includeYou) return { sharesPaise: shares, yourSharePaise: each + remainder }
  // You're not part of it, so the leftover paise have to land on someone else.
  shares[0] += remainder
  return { sharesPaise: shares, yourSharePaise: 0 }
}

export function yourShare(totalPaise: number, sharesPaise: number[]): number {
  return totalPaise - sharesPaise.reduce((s, p) => s + p, 0)
}

export function splitError(totalPaise: number, sharesPaise: number[]): string | null {
  if (sharesPaise.length === 0) return 'Add at least one person to split with'
  if (sharesPaise.some((p) => p <= 0)) return "Each person's share must be more than ₹0"
  if (yourShare(totalPaise, sharesPaise) < 0)
    return "Other people's shares can't be more than the bill"
  return null
}

/**
 * Each person's share of a different amount, in paise — the same rule the server applies: keep
 * the proportion, round half up, and if rounding goes past the amount the largest share gives
 * the extra paise back.
 */
export function scaleSharesPaise(
  sharesPaise: number[],
  expectedPaise: number,
  amountPaise: number
): number[] {
  if (amountPaise === expectedPaise) return sharesPaise
  const scaled = sharesPaise.map((s) => Math.max(1, Math.round((s * amountPaise) / expectedPaise)))
  const excess = scaled.reduce((a, b) => a + b, 0) - amountPaise
  if (excess > 0) {
    const largest = scaled.indexOf(Math.max(...scaled))
    scaled[largest] -= excess
  }
  return scaled
}
